const getOptions = (filterName) => {
  let filterTitles;
  switch (filterName) {
    case 'isActive':
      filterTitles = ['Active', 'Inactive'];
      break;
    case 'isDirect':
      filterTitles = ['Yes', 'No'];
      break;
    case 'isFinancialAccount':
      filterTitles = ['Yes', 'No', 'N/A'];
      break;
    case 'isValid':
    case 'formIsValid':
      filterTitles = ['Valid', 'Invalid'];
      break;
    default:
      break;
  }
  if (filterTitles) {
    const options = [
      { title: filterTitles[0], value: 'true' },
      { title: filterTitles[1], value: 'false' }
    ];
    if (filterTitles.length === 3) {
      options.push({ title: filterTitles[2], value: 'null' });
    }
    return options;
  }
  return [];
};

export default getOptions;
